// @flow
import { createMeta } from "../../../components/TapHeader";

const title = "Your profile";
export const TapProfileMeta = createMeta(title);
